// import { defineAsyncComponent } from 'vue';
import PSwp from '@/components/pswp.vue';
import SharePopper from '../_components/share-popper.vue';
import { mapState as rootMapState } from 'pinia';
import { usePageStore, useUserStore } from "@/store";

import { mapState, mapActions } from '@/store/helpers';
import global from '@/common/global';
import signLog from '@/components/sign-log';
import popMgr from '@/components/global/popMgr';
import SharePop from '../_components/share-pop.vue';
import isOpenWin from '../../md-detail-info/openWinUrl';
import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';
import breadCrumb from "../breadCrumb";
import { isUrls } from '@/router/index.js';

function getMatterPort(links = []) {
    let reg = /matterport\.(com|cn)\/show/;
    let matterPortLink = links.find(l => reg.test(l));
    if (!matterPortLink) {
        return false; 
    }
    return {
        type: '3d',
        url: matterPortLink,
        preview:
            '//cdn.chime.me/image/fs/sitebuild/site-cms/listing-detail/3d.jpeg'
    };
}
const Virtual_Icon_Map = {
    classic: 'icon-3d-template4',
    fashion: 'icon-3d-template4',
    standard: 'icon-3d'
};
const Video_Icon_Map = {
    classic: 'icon-video',
    fashion: 'icon-video',
    standard: 'icon-video2'
};
export default {
    i18next: {
        ns: 'md-sold-detail'
    },
    inject: ['click3D', 'getMediaPopIns', 'getGalleryPopIns'],
    components: {
        Swiper,
        Slide: SwiperSlide,
        PSwp,
        SharePopper,
        breadCrumb
    },
    props: {
        submitText: {
            type: String,
            default: null
        }
    },
    data: function() {
        return {
            defaultImg:
                '//fs01.chime.me/image/fs/sitebuild/2021224/20/original_ddff9285-b8a4-4fd5-840f-0233eb9cc979.png',
            allImages: [],
            swiperReady: false,
            canRight: false,
            canLeft: false,
            curPage: 0,
            lazyload: true,
            photoswipeOption: {},
            slidesPerGroup: 1,
            space: 0,
            mobileStep: 1,
            pcStep: 1,
            speed: 1000,
            video: null,
            imageStartIndex: 0,
            theme: '',
            fixedBannerStyle: null,
            enableNavigation: true,
            loop: false,
            slidesPerGroupType: ''
        };
    },
    created() {
        this.init();
    },
    mounted() {
        global.scroll(this.onScroll);
        this.fixedBannerStyle = {
            paddingRight: `${
                window.innerWidth - this.$refs.banner.offsetWidth
            }px`
        };
    },
    watch: {
        tourBtnList() {
            this.updateTourBtn(this.tourBtnList);
        }
    },
    computed: {
        notApp() {
            return !this.platform.inApp;
        },
        cmpRequestButtonText() {
            return this.$t('md-sold-detail.requestAFreeAnalysis')
        },
        ...rootMapState(usePageStore, {
            pageKey: store => store.page.pageKey
        }),
        ...rootMapState(useUserStore, {
            user: store => store.user,
        }),
        ...mapState({
            info: store => store.listingDetail.info || {},
            shares: store => store.shares
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        slidesPerView() {
            return 1;
        },
        imgAlt() {
            return (
                this.info &&
                [this.info.cityAddress, this.info.streetAddress]
                    .filter(_ => _)
                    .join()
            );
        },
        videoImgAlt() {
            return [this.imgAlt, this.$t('md-sold-detail.videoTour')].join();
        },
        tourBtnList() {
            let { link, chimeVideoLink } = this.info;
            let tourBtnList = [],
                virtualLinks = link ? link.split(' ') : [],
                videoLinks = chimeVideoLink ? chimeVideoLink.split(' ') : [];
            if (virtualLinks.length > 0) {
                tourBtnList.push({
                    link: virtualLinks[0],
                    text: this.$t('md-sold-detail.virtualTour'),
                    icon: Virtual_Icon_Map[this.theme]
                });
            }
            if (videoLinks.length > 0) {
                tourBtnList.push({
                    link: videoLinks[0],
                    text: this.$t('md-sold-detail.videoTour'),
                    icon: Video_Icon_Map[this.theme]
                });
            }
            return tourBtnList;
        },
        options({ enableNavigation, slidesPerGroup, slidesPerView }) {
            let options = {
                speed: this.speed,
                spaceBetween: this.space,
                slidesPerGroup: slidesPerGroup,
                slidesPerView: slidesPerView,
                loop: this.loop,
                loopFillGroupWithBlank:
                    this.slidesPerGroupType === 'full' ? true : false
            };
            if (enableNavigation) {
                options.navigation = {
                    prevEl: '.swiper-button-prev',
                    nextEl: '.swiper-button-next',
                    disabledClass: 'swiper-button-disabled'
                };
            }

            options = fixSwiperOptions(options);
            return options;
        }
    },
    methods: {
        ...mapActions(['updateTourBtn']),
        init() {
            let listingPictures = !this.info.listingPictures
                ? []
                : this.info.listingPictures.split('|');

            let { link, chimeVideoLink } = this.info;
            let virtualLinks = link ? link.split(' ') : [],
                videoLinks = chimeVideoLink ? chimeVideoLink.split(' ') : [];
            let matterport = getMatterPort([...virtualLinks, ...videoLinks]);
            if (matterport) {
                listingPictures.splice(1, 0, matterport);
                this.imageStartIndex = 1;
            }
            if (listingPictures.length === 0) {
                listingPictures.push(
                    '//fs01.chime.me/image/fs/sitebuild/2021224/20/original_ddff9285-b8a4-4fd5-840f-0233eb9cc979.png'
                );
            }
            this.allImages = listingPictures;
            if (!this.isMobileSize && this.allImages.length > this.pcStep) {
                this.canRight = true;
            }
            this.updateTourBtn(this.tourBtnList);
        },
        handleSlideChange(swiper) {
            this.curPage = swiper.activeIndex + 1;
        },
        onSwiperReady(swiper) {
            this.photoswipeOption.mySwiper = swiper;
            this.photoswipeOption.images = this.allImages;
            this.photoswipeOption.elems =
                this.$el.querySelectorAll('.swiper-img img');
            if (this.isMobileSize) {
                this.photoswipeOption.swiperNum = this.mobileStep;
            } else {
                this.photoswipeOption.swiperNum = this.pcStep;
            }
        },
        touched(index, $event, item = {}) {
            const type = item && item.type,
                url = item && item.url;
            // const url = `https://www.dropbox.com/s/2lza92tb05edq6p/27th%20HPP%20Final.mov?dl=0`
            if (url && type && type !== 'img' && isOpenWin(url, window.sitePrepareData())) {
                window.open(url, '_blank');
                return;
            }
            if (this.isMobileSize) {
                if (item?.type === '3d') {
                    index--;
                }
                const realIndex = index <= 0 ? 0 : index;
                this.getMediaPopIns()?._openMediaPop(realIndex);
            } else {
                this.getGalleryPopIns()?._openGalleryPop(index, $event, item);
            }
        },
        onImgLoad(index, $event) {
            if (this.video && this.video.videoLink) {
                this.$refs.pswp.updateImgSize(
                    index - 1,
                    $event.width,
                    $event.height
                );
            } else {
                this.$refs.pswp.updateImgSize(
                    index,
                    $event.width,
                    $event.height
                );
            }
        },
        putAway() {
            if (window.parent !== window && window.parent.__curDetailPop) {
                window.parent.__curDetailPop.hide();
            } else {
                let url =
                    this.pageKey === 'listing-detail'
                        ? isUrls({ name: 'listing' })
                        : this.pageKey === 'listing-detail-sold'
                            ? isUrls({ name: 'sold-listing' })
                            : '/';
                window.siteAppVm.$EventBus.$emit('change-url', url);
            }
        },
        onScroll() {
            //  Specifically implemented in each set of styles
        },
        request() {
            signLog.register(
                {
                    registerTitle: null,
                    submitRegister: this.submitText
                },
                'evaluationRegister'
            );
        },
        sharePop() {
            popMgr.create(SharePop, {
                shares: this.shares,
                theme: this.theme
            });
        }
    },
    unmounted() {
        global.scroll(this.onScroll, true);
    }
};
